import isEmpty from 'lodash.isempty';

function buildQueryString(config) {
	const fieldsSeparator = ',';
	let queryString;
	let configKeys;

	function getFields(fieldsArray) {
		return fieldsArray.join(fieldsSeparator);
	}

	function getEmbeddedModels(embeddedModelsArray) {
		const modelPropertySeparator = '|';
		const modelSeparator = '/';
		let modelsString = '';

		embeddedModelsArray.forEach((model, index) => {
			modelsString += model.name;

			for (let modelProperty in model) {
				if (modelProperty !== 'name') {
					if (Array.isArray(model[modelProperty])) {
						modelsString +=
							modelPropertySeparator +
							modelProperty +
							'=' +
							getFields(model[modelProperty]);
					} else {
						modelsString +=
							modelPropertySeparator +
							modelProperty +
							'=' +
							encodeURIComponent(model[modelProperty]);
					}
				}
			}

			if (index < embeddedModelsArray.length - 1) {
				modelsString += modelSeparator;
			}
		});

		return modelsString;
	}

	if (!isEmpty(config)) {
		queryString = '?';
		configKeys = Object.keys(config);

		configKeys.forEach((key, index) => {
			if (key === 'embed') {
				queryString += key + '=' + getEmbeddedModels(config[key]);
			} else if (Array.isArray(config[key])) {
				queryString += key + '=' + getFields(config[key]);
			} else {
				queryString += key + '=' + encodeURIComponent(config[key]);
			}

			if (index < configKeys.length - 1) {
				queryString += '&';
			}
		});

		return queryString;
	}

	return '';
}

function getRoutePath(config) {
	let routePath = '/api/';

	if (config.public) {
		routePath += 'public/' + config.entityPathSegment + '/';
	} else {
		routePath += config.entityPathSegment + '/';
	}

	if (Array.isArray(config.additionalPathSegments)) {
		routePath += config.additionalPathSegments.join('/') + '/';
	}

	if (config.queryString) {
		routePath += config.queryString;
	}

	return routePath;
}

export { buildQueryString, getRoutePath };
